import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  BoxTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  Dashboard: {
    flexGrow: 1,
    overflow: 'auto',
    height: '100%',
    padding: '16px 24px',
  },
  BoxDownload: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '18px',
  },
  BoxDetails: {
    display: 'flex',
    gap: '8px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  BoxSummary: {
    display: 'flex',
    gap: '16px',
    justifyContent: 'center',
    alignItems: 'end',
    flexDirection: 'column',
    width: '100%',
    padding: '8px',
  },
  Title: {
    color: 'var(--Gray-900, #101828)',
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px',
  },
  Table: {
    width: '100%',
    borderRadius: '12px',
    background: 'var(--Base-White, #FFF)',
    boxShadow: '0px 1px 3px 0px rgba(16, 24, 40, 0.10), 0px 1px 2px 0px rgba(16, 24, 40, 0.06)',
  },
  Scrollbar: {
    height: 'calc(100dvh - 580px)',
    '&::-webkit-scrollbar': {
      width: '8px',
      height: '8px',
      backgroundColor: '#f5f5f5',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#888',
      borderRadius: '4px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#555',
    },
  },
  TableCell: {
    border: '1px solid #e0e0e0',
    padding: '8px',
  },
  RadioGroup: {
    display: 'flex',
    flexDirection: 'column',
    '& .MuiButtonBase-root ': {
      padding: '2px',
    },
    '& .MuiFormControlLabel-label': {
      marginLeft: '4px',
      fontSize: '13px',
      fontWeight: 600,
    },
  },
}));

export { useStyles };

